import React, { Component } from 'react';
import { Grid, Col, Image } from 'react-bootstrap';
import './about.css';

class About extends Component {
    render() {
        return (
            <div>
                <Image src={require('./assets/JoyZhang.jpg')} className="home-header-image"/>
                <Grid>
                    <Col xs={12} sm={12}>
                        <p className="about-description">
                        <p>I'm a software engineer and fourth year computer science student at the University of British Columbia. I have interned at Hootsuite (Winter 2017) and Microsoft(Spring 2018), and am always curious and eager to learn.
                        </p>
                        <p>When I'm not coding, I like to travel and hunt down delicious food to eat.</p>
                        <p>Feel free to reach out!</p>
                        <div className="contact-icon-container">
                            <a href="https://github.com/joy8zhang"><Image src={require('./assets/github.svg')} className="contact-icon"/></a>
                            <a href="https://www.linkedin.com/in/joy8zhang/"><Image src={require('./assets/linkedin.svg')} className="contact-icon"/></a>
                            <a href="mailto:contactjoyzhang@gmail.com"><Image src={require('./assets/email.svg')} className="contact-icon"/></a>
                            <a href="https://devpost.com/joy8zhang"><Image src={require('./assets/devpost.svg')} className="contact-icon"/></a>
                        </div>
                        </p>
                    </Col>
                </Grid>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/about.js